import { useEffect, useState } from 'react'
import { useApi } from '../lib/api'

interface Props {
  id: number
  type: 'country' | 'custom'
  imageUrl: string | null
  name: string
  width?: number
  height?: number
}

export function FlagThumbnail({ id, type, imageUrl, name, width = 48, height = 30 }: Props) {
  const { fetchBlob } = useApi()
  const [src, setSrc] = useState<string | null>(null)

  useEffect(() => {
    if (type === 'country' && imageUrl) {
      setSrc(imageUrl)
      return
    }
    if (type === 'custom') {
      let objectUrl: string | null = null
      fetchBlob(`/api/flags/${id}/image`)
        .then((url) => { objectUrl = url; setSrc(url) })
        .catch(() => setSrc('error'))
      return () => { if (objectUrl) URL.revokeObjectURL(objectUrl) }
    }
  }, [id]) // eslint-disable-line react-hooks/exhaustive-deps

  if (src === 'error') {
    return (
      <div style={{
        width, height, background: '#fee2e2', borderRadius: 2,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 11, color: '#dc2626',
      }}>!</div>
    )
  }
  if (!src) {
    return <div style={{ width, height, background: '#e5e7eb', borderRadius: 2 }} />
  }
  return (
    <img
      src={src}
      alt={name}
      style={{ width, height, objectFit: 'cover', borderRadius: 2, display: 'block', border: '1px solid #e5e7eb' }}
    />
  )
}
